import React, { Component } from "react";
import { Row, Col, Collapse } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import classname from "classnames";
import logo from "../../assets/images/logo.jpg";
import "./Header.css";

//i18n
import { withNamespaces } from "react-i18next";
// import GETApiCall from "../../GETAPI";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReport: false,
      Details: [],
      menuDetails: [
        {
          fld_menuname: "Dashboard",

          fld_pagename: "/admin_dashboard",

          fld_show: "1",

          fld_menuid: 1,
        },

        {
          fld_menuname: "Monthly Collection",

          fld_pagename: "/#",

          fld_show: "1",

          fld_menuid: 2,
        },

        // {  "fld_menuname": "Daily Collection",

        // "fld_pagename": "/#",

        // "fld_show": "1",

        // "fld_menuid": 3},

        {
          fld_menuname: "User Management",

          fld_pagename: "/user_list",

          fld_show: "1",

          fld_menuid: 4,
        },
        {
          fld_menuname: "Report",

          fld_pagename: "/#",

          fld_show: "1",

          fld_menuid: 4,
        },
      ],

      SubMenuDetails: {
        Dashboard: [],
        "Monthly Collection": [
          {
            fld_menuname: "Transactions",

            fld_pagename: "/transaction_list",

            fld_show: "1",

            fld_parentid: 2,
          },

          {
            fld_menuname: "Approve Client",

            fld_pagename: "/approve_client",

            fld_show: "1",

            fld_parentid: 3,
          },
          {
            fld_menuname: "Manage Clients",
            fld_pagename: "/#",

            fld_show: "1",

            fld_parentid: 1,
          },

          {
            fld_menuname: "Offline Payment",

            fld_pagename: "/#",

            fld_show: "1",

            fld_parentid: 4,
          },

          {
            fld_menuname: "Close Account",

            fld_pagename: "/#",

            fld_show: "1",

            fld_parentid: 5,
          },
        ],

        Report: [
          {
            fld_menuname: "Transaction Report",

            fld_pagename: "/transactionReport",

            fld_show: "1",

            fld_parentid: 2,
          },
        ],
      },

      childMenuDetails: {
        "Manage Clients": [
          {
            fld_menuname: "Add New Client",

            fld_pagename: "/add_new_client",

            fld_show: "1",

            fld_childId: 2,
          },

          {
            fld_menuname: "View Client",

            fld_pagename: "/view_client",

            fld_show: "1",

            fld_childId: 2,
          },
        ],

        "Offline Payment": [
          {
            fld_menuname: "Payment",

            fld_pagename: "/offline_payment",

            fld_show: "1",

            fld_childId: 2,
          },
          {
            fld_menuname: "Acknowledgement",

            fld_pagename: "/offline_acknowledgement",

            fld_show: "1",

            fld_childId: 2,
          },
        ],

        "Close Account": [
          {
            fld_menuname: "Close Account",

            fld_pagename: "/close_account",

            fld_show: "1",

            fld_childId: 2,
          },
          {
            fld_menuname: "Closed Account List",

            fld_pagename: "/close_account_list",

            fld_show: "1",

            fld_childId: 2,
          },
        ],
      },
    };
  }

  componentDidMount() {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }

    var login = localStorage.getItem("LoginDetail");
    var details = JSON.parse(login);
    // console.log(details[0].fld_usertype)
    this.setState({
      Details: details[0],
    });
  }

  activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  };

  render() {
    // console.log(this.state.Details.fld_usertype)

    return (
      <React.Fragment>
        <div className="topnav">
          <div className="mx-auto">
            <nav
              className="navbar navbar-light navbar-expand-lg topnav-menu navlogoPaymentphnview"
              id="navigation"
            >
              <div className="navbar-brand-box ">
                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img
                      src={logo}
                      alt=""
                      height="28"
                      style={{ margin: "0px" }}
                    />
                  </span>
                  <span className="logo-lg">
                    <img
                      src={logo}
                      alt=""
                      height="44"
                      style={{ margin: "0px 0px 0px -20px" }}
                    />
                  </span>
                </Link>
              </div>

              {this.state.Details.fld_usertype == "Customer" ? (
                // <Collapse
                //   isOpen={this.props.menuOpen}
                //   className="navbar-collapse"
                //   id="topnav-menu-content"
                // >
                <>
                  <ul className="navbar-nav nav-Paymenthistory navdesktop">
                    <li className="nav-item ">
                      <Link
                        to="/dashboard"
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        Dashboard
                      </Link>
                    </li>
                    {/* <li className="nav-item ">
                      <Link
                        to="/chits"
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        Payment History
                      </Link>
                    </li> */}
                  </ul>

                  {/* for small device --------------------- */}
                  <ul className="navbar-nav nav-Paymenthistory navextrasmall" style={{marginLeft: '18px'}}>
                    <li className="nav-item mt-2">
                    <Link to="/">
                      <img
                        src={logo}
                        alt=""
                        height="28"
                        style={{ margin: "0px" }}
                      />
                      </Link>
                    </li>
                    <li className="nav-item ">
                      <Link
                        to="/dashboard"
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        Dashboard
                      </Link>
                    </li>
                    <li className="nav-item ">
                      {/* <Link
                        to="/chits"
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        Payment History
                      </Link> */}
                    </li>
                  </ul>
                </>
              ) : (
                // </Collapse>
                // <Collapse
                //   isOpen={this.props.menuOpen}
                //   className="navbar-collapse"
                //   id="topnav-menu-content"
                // >
                this.state.Details.fld_usertype == "Admin"? (
                <ul className="navbar-nav d-flex nav-Paymenthistory">
                  {this.state.menuDetails &&
                    this.state.menuDetails.map((data, i) => {
                      return (
                        <li className="nav-item dropdown">
                          {data.fld_pagename != "/#" ? (
                            <Link
                              to={`${data.fld_pagename}`}
                              className="nav-link dropdown-toggle arrow-none"
                            >
                              {this.props.t(`${data.fld_menuname}`)}
                            </Link>
                          ) : (
                            <li className="nav-item dropdown">
                              <Link className="nav-link dropdown-toggle arrow-none">
                                {this.props.t(`${data.fld_menuname}`)}{" "}
                                <div className="arrow-down"></div>
                              </Link>

                              <div
                                className={classname(
                                  "dropdown-menu mega-dropdown-menu dropdown-mega-menu-md  px-2",
                                  { show: this.state.uiState }
                                )}
                              >
                                {this.state.SubMenuDetails[data.fld_menuname] &&
                                  this.state.SubMenuDetails[
                                    data.fld_menuname
                                  ].map((data, i) => {
                                    if (data.fld_pagename !== "/#") {
                                      return (
                                        <Link
                                          to={`${data.fld_pagename}`}
                                          className="dropdown-item"
                                        >
                                          {this.props.t(`${data.fld_menuname}`)}
                                        </Link>
                                      );
                                    } else {
                                      return (
                                        <div className="dropdown">
                                          <a className="dropdown-item dropdown-toggle arrow-none">
                                            {this.props.t(
                                              `${data.fld_menuname}`
                                            )}
                                            <div className="arrow-down"></div>
                                          </a>

                                          <div className="dropdown-menu">
                                            {this.state.childMenuDetails[
                                              data.fld_menuname
                                            ] &&
                                              this.state.childMenuDetails[
                                                data.fld_menuname
                                              ].map((data) => {
                                                return (
                                                  <Link
                                                    to={`${data.fld_pagename}`}
                                                    className="dropdown-item"
                                                  >
                                                    {this.props.t(
                                                      `${data.fld_menuname}`
                                                    )}
                                                  </Link>
                                                );
                                              })}
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}
                              </div>
                            </li>
                          )}
                        </li>
                      );
                    })}
                </ul>):null
                // </Collapse>
              )}
            </nav>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(withNamespaces()(Navbar));
